import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { L10nTranslationService, L10nTranslationModule } from 'angular-l10n';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-edp-edit-failed',
  templateUrl: './edp-edit-failed.component.html',
  styleUrl: './edp-edit-failed.component.scss',
  imports: [
    MatButton,
    MatDialogClose,
    MatIcon,
    L10nTranslationModule,
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    MatDialogActions,
  ],
})
export class EdpEditFailedComponent {
  public dialogRef = inject(MatDialogRef<EdpEditFailedComponent>);
  private readonly data = inject<{ isClipboard: boolean }>(MAT_DIALOG_DATA, { optional: true });
  public translationService = inject(L10nTranslationService);
  message: string;
  private readonly messageOne = this.translationService.translate('shared.messageOne');
  private readonly messageTwo = this.translationService.translate('shared.messageTwo');
  private readonly clipboardMessage = this.translationService.translate('shared.clipboardMessage');
  constructor() {
    this.message = this.composeMessage();
  }
  composeMessage() {
    return `${this.messageOne} ${!!this.data && this.data.isClipboard ? this.clipboardMessage + ' ' : ''}${
      this.messageTwo
    }`;
  }
  onClose(retry: boolean) {
    this.dialogRef.close(retry);
  }
}
